<template>
	<div>
		<h4>Bilan Ev RP</h4>
		<b-tabs lazy content-class="mt-3" active-nav-item-class="font-weight-bold">
			<template v-for="unite in unites">
				<b-tab :key="unite.id" active class="outlineLess">
					<template slot="title">
						<i style="padding-right:5px;"></i>{{ unite.nomUnite }}
					</template>
					<p>
						<b-table-simple ref="tableBilan" small responsive show-empty>
							<colgroup>
								<col>
								<col>
								<col>
								<col>
								<col>
								<col>
								<col>
								<col>
								<col>
								<col>
							</colgroup>
							<b-thead>
								<b-tr>
									<b-th class="firstHead">Risques identifiés</b-th>
									<b-th class="bilanHeadUnit">Situations exposant au risque</b-th>
									<b-th class="bilanHeadUnit">Fréquence</b-th>
									<b-th class="bilanHeadUnit">Gravité</b-th>
									<b-th class="bilanHeadUnit">Niveau de risque (NR)</b-th>
									<b-th class="bilanHeadUnit" >Moyens de Prévention existants</b-th>
									<b-th class="bilanHeadUnit">Niveau de maitrise (NM)</b-th>
									<b-th class="bilanHeadUnit">Niveau de risque subsistant (NRS)</b-th>
									<b-th class="bilanHeadUnit">Proposition de plan d'actions</b-th>
									<b-th class="bilanHeadUnit">Site</b-th>
								</b-tr>
							</b-thead>
							<b-tbody>
								<template v-for="donnee in getDonnees(unite.id)">
										<template :key="donnee.id" v-for="(risque,index) in donnee.risques">
											<template v-if="index == 0">
												<b-tr>
													<b-td class="nomFamille" :rowspan="donnee.risques.length">{{ donnee.famille.nomFamille }}</b-td>
													<b-td :key="risque.id" class="nomFamille">{{ risque.nomRisque }}</b-td>
													<b-td :key="risque.id" class="nomFamille" style="text-align: center;">{{ risque.data.ps }}</b-td>
													<b-td :key="risque.id" class="nomFamille" style="text-align: center;">{{ risque.data.g }}</b-td>
													<b-td :key="risque.id" :style="{'background-color': getCouleurRisque(risque.data.risqueBrut, 'brut'), 'text-align': 'center'}" class="nomFamille">{{ risque.data.risqueBrut }}</b-td>
													<b-td :key="risque.id" class="nomFamille">{{ risque.data.observation }}</b-td>
													<b-td :key="risque.id" class="nomFamille" style="text-align: center;">{{ risque.data.d }}</b-td>
													<b-td :key="risque.id" :style="{'background-color': getCouleurRisque(risque.data.risqueResiduel, 'residuel'), 'text-align': 'center'}" class="nomFamille">{{ risque.data.risqueResiduel }}</b-td>
													<b-td :key="risque.id" class="nomFamille">{{getStringActions(risque.data.actions)}}</b-td>
													<b-td :key="risque.id" class="nomFamille">{{ risque.data.site }}</b-td>
												</b-tr>
											</template>
											<template v-else>
												<b-tr :key="risque.id">
													<b-td :key="risque.id" class="nomFamille">{{ risque.nomRisque }}</b-td>
													<b-td :key="risque.id" class="nomFamille" style="text-align: center;">{{ risque.data.ps }}</b-td>
													<b-td :key="risque.id" class="nomFamille" style="text-align: center;">{{ risque.data.g }}</b-td>
													<b-td :key="risque.id" :style="{'background-color': getCouleurRisque(risque.data.risqueBrut, 'brut'), 'text-align': 'center'}" class="nomFamille">{{ risque.data.risqueBrut }}</b-td>
													<b-td :key="risque.id" class="nomFamille">{{ risque.data.observation }}</b-td>
													<b-td :key="risque.id" class="nomFamille" style="text-align: center;">{{ risque.data.d }}</b-td>
													<b-td :key="risque.id" :style="{'background-color': getCouleurRisque(risque.data.risqueResiduel, 'residuel'), 'text-align': 'center'}" class="nomFamille">{{ risque.data.risqueResiduel }}</b-td>
													<b-td :key="risque.id" class="nomFamille">{{getStringActions(risque.data.actions)}}</b-td>
													<b-td :key="risque.id" class="nomFamille">{{ risque.data.site }}</b-td>
												</b-tr>
											</template>
										</template>
										<!-- <template v-for="unite in unites">
											<b-td :class="{'eval': true, 'bg-red': getEvalBrut(unite.id, famille.id) === max_cotation_brut.note, 'bg-orange': getEvalBrut(unite.id, famille.id) === second_max_cotation_brut.note}" :key="unite.id"> {{ getEvalBrut(unite.id, famille.id) }} </b-td>
											<b-td :class="{'eval': true, 'bg-red': getEvalResiduel(unite.id, famille.id) === max_cotation_residuel.note, 'bg-orange': getEvalResiduel(unite.id, famille.id) === second_max_cotation_residuel.note}" :key="unite.id"> {{ getEvalResiduel(unite.id, famille.id) }} </b-td>
										</template>
										<b-td class="numeroAction">
											<div contenteditable="true" class="editme" @blur="onEditFamille" @keydown.enter="endEditFamille" editField='numerosAction' :editId="famille.id" :dataInit="getNumeroAction(famille.id)">{{ getNumeroAction(famille.id) }}</div>
											<i class="fas fa-plus" @click="addProgAction(progAction, famille.nomFamille)" style="color:green; cursor:pointer;"></i>
										</b-td> -->
								</template>
							</b-tbody>
						</b-table-simple>
					</p>
				</b-tab>
			</template>
		</b-tabs>
		
		<h5>Niveau de risque (NR)</h5>
		<div class="zoneClassification" v-for="(cotation, index) in cotation.brut" :key="index">
			<div :style="{'height':'25px','width':'25px','margin-right':'3px','background-color':cotation.couleur}"></div>
			<span> : {{ cotation.desc }}</span>
		</div>
		<br>
		<h5>Niveau de risque subsistant (NRS)</h5>
		<div class="zoneClassification" v-for="(cotation, index) in cotation.residuel" :key="index">
			<div :style="{'height':'25px','width':'25px','margin-right':'3px','background-color':cotation.couleur}"></div>
			<span> : {{ cotation.desc }}</span>
		</div>
	</div>
</template>

<script>
import moment from "moment"
import scriptQse from '../../../script/script-qse.js';
export default {
	data () {
		return {
			max_cotation_brut: {},
			second_max_cotation_brut: {},
			max_cotation_residuel: {},
			second_max_cotation_residuel: {},
		}
	},
	methods:{
		updateExtrafieldsQse: scriptQse.updateExtrafieldsQse,
		getEvalBrut(idUnite, idFamilles) {
			let data = null
			var dataUnites = this.donnees.unites.filter(unite => (unite.id == idUnite))
			dataUnites.forEach(dataUnite => {
				let dataFamilles = dataUnite.familles.filter(famille => (famille.id == idFamilles))
				dataFamilles.forEach(dataFamille => {
					data = dataFamille.evalBrutFinale
				})
			})
			return data
		},
		getStringActions(actions){
			var stringActions = ""
			if(actions.length){
				actions.forEach((element, index) => {
					let indexAction = this.progAction.findIndex(action => action.numProgAction == element)
					if(indexAction === -1) return // ← action introuvable, on skip
					
					if(index > 0){
						stringActions += " , " + this.progAction[indexAction].typeAction
					} else {
						stringActions += this.progAction[indexAction].typeAction
					}
				})
			}
			return stringActions
		},
		getDonnees(uniteId){
			let donnees = []

			this.familles.forEach(elementFamille => {
				let risquesRes = this.risques.filter(risque => risque.idFamille == elementFamille.id)
				var dataUnites = this.donnees.unites.filter(unite => (unite.id == uniteId))
				if(risquesRes.length){
					let tabRisques = []
					risquesRes.forEach(risqueRes => {
						dataUnites.forEach(dataUnite => {
							let dataRisques = dataUnite.risques.filter(risque => ((risque.id == risqueRes.id)&&(risque.presence)))
							if(dataRisques.length){
								tabRisques.push({
									nomRisque: risqueRes.nomRisque,
									data: dataRisques[0]
								})
							}
						})
					})
					if(tabRisques.length){
						donnees.push({
							famille: elementFamille,
							risques: tabRisques
						})
					}
				}
				
			})
			if(!donnees.length){
				this.$bvToast.toast(`Aucune données dans l'unité`, {
                    title: 'Données',
                    toaster: 'b-toaster-bottom-right',
                    variant: 'danger',
                    autoHideDelay: 10000,
                    appendToast: true,
                    solid: true,
                })
			}
			return donnees
		},
		getNameFamille(familleID){
			let risques = []
			this.risques.forEach(element => {
				var dataUnites = this.donnees.unites.filter(unite => (unite.id == uniteId))
				dataUnites.forEach(dataUnite => {
					let dataRisques = dataUnite.risques.filter(risque => (risque.presence))
					risques.push({
						schema: element,
						data: dataRisques[0]
					})
				})
			})
			console.log(risques)
			return risques.filter(risque => (risque.schema.idFamille == famille))
		},
		getEvalResiduel(idUnite, idFamilles) {
			let data = null
			var dataUnites = this.donnees.unites.filter(unite => (unite.id == idUnite))
			dataUnites.forEach(dataUnite => {
				let dataFamilles = dataUnite.familles.filter(famille => (famille.id == idFamilles))
				dataFamilles.forEach(dataFamille => {
					data = dataFamille.evalResiduelFinale
				})
			})
			return data
		},
		getNumeroAction(idFamilles) {
			let data = null
			this.donnees.unites.forEach(unite => {
				let dataFamilles = unite.familles.filter(famille => (famille.id == idFamilles))
				data = dataFamilles[0].numerosAction
			})

			return data
		},
		onEditFamille (evt) {
			var initValue = evt.target.getAttribute('dataInit')
			var newValue = evt.target.innerText
			var editField = evt.target.getAttribute('editField')
			var editId = evt.target.getAttribute('editId')

			if (newValue !== initValue) {
				this.donnees.unites.forEach(unite => {
					let dataFamilles = unite.familles.filter(famille => (famille.id == editId))
					dataFamilles.forEach(dataFamille => {
						dataFamille[editField] = newValue
					})
				})
				evt.target.setAttribute('dataInit', newValue)
				this.updateExtrafieldsQse(this.$store.state.infoSoc.id)
			}
		},

		endEditFamille (evt) {
			evt.target.blur(evt)
		},
		loadNumeroAction (){
			let numeroAction = []
			this.donnees.unites.forEach(unite => {
				unite.familles.forEach(dataFamille => {
					var numAct = numeroAction.filter(act => (act.idFamille == dataFamille.id))
					if((dataFamille.numerosAction) && (dataFamille.numerosAction != 'Non défini') && (!numAct.length)){
						numeroAction.push({idFamille:dataFamille.id, action:dataFamille.numerosAction})
					}
				})
			})

			this.donnees.unites.forEach(unite => {
				unite.familles.forEach(dataFamille => {
					var numAct = numeroAction.filter(act => (act.idFamille == dataFamille.id))
					numAct.forEach(element => {
						dataFamille.numerosAction = element.action
					})
				})
			})
		},
		addProgAction(rows, risque) {
			let dateNow = moment().format("YYYY-MM-DD")
			rows.push({
				'numProgAction':this.autoIncrementProgAction,
				'numAction':'Saisir un numéro d\'action', 
				'risque':risque, 
				'unite':[], 
				'situation':'Saisir une situation', 
				'typeAction':'Saisir un type d\'action', 
				'effet':'Saisir l\'effet', 
				'pilote':'Saisir un pilote', 
				'delai': dateNow, 
				'avancement':'Saisir un avancement', 
				'budget':'Saisir un budget', 
				'commentaire':'Saisir un commentaire',
				'etat':'En cours'
			})
			this.$store.commit("updateAutoIncrementProgAction", parseInt(this.autoIncrementProgAction)+1)
			this.$store.commit("updateProgAction", this.progAction)
			this.updateExtrafieldsQse(this.$store.state.infoSoc.id)
		},
		maxCotations(array){
			let maxValue = 0;
			let maxcotation = [];
			array.forEach(obj => {
				if (parseInt(obj.cotationMax) > maxValue) {
					maxValue = obj.cotationMax;
					maxcotation = obj;
				}
			});
			return maxcotation;
		},
		getCouleurRisque(niveau, type) {
        if (!niveau && niveau !== 0) return '';
        
        // Convertir en nombre si c'est une string
        const niveauNum = parseInt(niveau);

		if (niveauNum === 0) {
			return '#000000'; // Noir
		}
        
        // Récupérer les cotations selon le type
        const cotations = type === 'brut' ? this.cotation.brut : this.cotation.residuel;
        
        if (!cotations || !cotations.length) return '';
        
        // Trier les cotations par cotationMax croissant (important !)
        const cotationsTriees = [...cotations].sort((a, b) => parseInt(a.cotationMax) - parseInt(b.cotationMax));
        
        // Trouver la cotation correspondante
        for (let i = 0; i < cotationsTriees.length; i++) {
            if (niveauNum <= parseInt(cotationsTriees[i].cotationMax)) {
                return cotationsTriees[i].couleur;
            }
        }
        
        // Si le niveau est supérieur au max, prendre la dernière couleur
        return cotationsTriees[cotationsTriees.length - 1].couleur;
    },
	},
	computed: {
		cotation(){
			return this.$store.state.cotation
		},
		unites () {
			return this.$store.state.unites
		},
		donnees() {
			return this.$store.state.donnees
		},
		familles() {
			return this.$store.state.famillesRisques.familles
		},
		progAction(){
			return this.$store.state.progAction
		},
		autoIncrementProgAction(){
			return this.$store.state.autoIncrementProgAction
		},
		risques () {
			return this.$store.state.famillesRisques.risques
		},
	},
	mounted: async function() {
		this.loadNumeroAction()
		this.max_cotation_brut = await this.maxCotations(this.$store.state.cotation.brut);
		this.second_max_cotation_brut = this.maxCotations(this.$store.state.cotation.brut.filter(cot => cot != this.max_cotation_brut));
		this.max_cotation_residuel = await this.maxCotations(this.$store.state.cotation.residuel);
		this.second_max_cotation_residuel = this.maxCotations(this.$store.state.cotation.residuel.filter(cot => cot != this.max_cotation_residuel));
	},
}
</script>

<style>
.table thead th.firstHead, .table thead th.secondHead, .table thead th.lastSecondHead, .table thead th.lastFirstHead{
	border-bottom:none;
	text-align: center;
    vertical-align: middle;
}

.table thead th.firstHead{
	border-top:1px solid black;
	border-left:1px solid black;
}

.table thead th.secondHead{
	border-top:none;
	border-left:1px solid black;
}

.table thead th.lastSecondHead{
	border-top:none;
	border-right:1px solid black;
}

.table thead th.lastFirstHead{
	border-top:1px solid black;
	border-right:1px solid black;
}

.table thead th.bilanHeadUnit{
	border: 1px solid black;
	max-height: 15em;
	height: 15em;
	text-align: center;
    vertical-align: middle;
}

.table thead th.bilanHeadUnit:nth-child(2n){
	background: #F2F2F2;
}

.table tbody td.nomFamille{
	border: 1px solid black;
    vertical-align: middle;
	width: 400px;
    white-space: break-spaces;
}

.table tbody td.numeroAction{
	border: 1px solid black;
	text-align: center;
    vertical-align: middle;
	width: 200px;
    white-space: break-spaces;
}

.table tbody td.eval{
	text-align: center;
	vertical-align: middle;
	border: 1px solid black;
}

.table thead th.bilanHeadUnit span{
	display: inline-block;
	writing-mode: vertical-lr;
}

.table thead th.risqueHeadBilan{
	border: 1px solid black;
	max-height: 6em;
	height: 6em;
	text-align: center;
}

.table thead th.risqueHeadBilan span{
	display: inline-block;
	writing-mode: vertical-lr;
}

.bg-red {
  background-color: #dd0000;
}

.bg-orange {
  background-color: #ff7700;
}

.zoneClassification{
	display: flex;
	flex-wrap: nowrap;
	align-items: center;
}
</style>